export default [
  {
    path: '/book/list',
    name: 'book-list',
    component: () => import('@/views/book/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Book List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Book' }, { title: 'Book List', active: true }],
      permissions: ['book_list']
    }
  },
  {
    path: '/book/add',
    name: 'create-book',
    component: () => import('@/views/book/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Book',
      parent: 'BookList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Book', url: '/book/list' },
        { title: 'Add Book', active: true }
      ],
      permissions: ['book_create']
    }
  },
  {
    path: '/book/:id/edit',
    name: 'edit-book',
    component: () => import('@/views/book/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Book',
      parent: 'BookList',
      permissions: ['book_edit']
    }
  },

  /* ------------------------------------------------------- pauri & slok ------------------------------------------------------- */
  {
    path: '/book/:id/pauri',
    name: 'pauri',
    component: () => import('@/views/book/pauri/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Pauri & Slok',
      parent: 'BookList',
      permissions: ['book_edit']
    }
  },
  {
    path: '/book/:id/pauri/add/:type',
    name: 'add-pauri',
    component: () => import('@/views/book/pauri/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Pauri',
      parent: 'BookList',
      permissions: ['book_edit']
    }
  },
  {
    path: '/book/:id/pauri/edit/:pauriId/:type',
    name: 'edit-pauri',
    component: () => import('@/views/book/pauri/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Pauri',
      parent: 'BookList',
      permissions: ['book_edit']
    }
  },

  /* ------------------------- pankti for solo readng ------------------------- */
  {
    path: '/book/:id/solo-book/update',
    name: 'update-solo-book',
    component: () => import('@/views/book/solo-book/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Pankti',
      parent: 'BookList',
      permissions: ['book_edit']
    }
  },

  /* ------------------------- highlight feedback ------------------------- */
  {
    path: '/book/:id/highlight-feedback/list/:type',
    name: 'highlight-feedback',
    component: () => import('@/views/book/highlight-feedback/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Highlight Feedback List',
      parent: 'BookList',
      permissions: ['book_edit']
    }
  },

  /* ------------------------- report a problem ------------------------- */
  {
    path: '/book/:id/report-problems/list',
    name: 'report-problems',
    component: () => import('@/views/book/report-problems/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Report a Problem',
      parent: 'BookList',
      permissions: ['book_edit']
    }
  }
]
